import React from "react";

const termsOfUseAppParagraphs = [
  "PRIVACY POLICY",
  "MYPREGA APPLICATION",
  "Operated By REMEDINART MEDICO SERVICES PRIVATE LIMITED",
  "Effective Date: [06/05/2026]",
  "THIS PRIVACY POLICY GOVERNS THE COLLECTION, STORAGE, PROCESSING, USE, DISCLOSURE, TRANSFER, RETENTION, AND PROTECTION OF PERSONAL DATA AND SENSITIVE PERSONAL DATA COLLECTED THROUGH THE MYPREGA PLATFORM (“PLATFORM” / “APPLICATION” / “SERVICES”) OPERATED BY REMEDINART MEDICO SERVICES PRIVATE LIMITED (“COMPANY” / “WE” / “US” / “OUR”).",
  "BY ACCESSING, REGISTERING, USING, OR CONTINUING TO USE THE PLATFORM, THE USER (“USER” / “YOU” / “YOUR”) EXPRESSLY CONSENTS TO THE COLLECTION, PROCESSING, STORAGE, ANALYSIS, USE, DISCLOSURE, TRANSFER, AND HANDLING OF PERSONAL DATA AND SENSITIVE PERSONAL DATA IN ACCORDANCE WITH THIS PRIVACY POLICY, THE DIGITAL PERSONAL DATA PROTECTION ACT, 2023 (“DPDP ACT”), THE INFORMATION TECHNOLOGY ACT, 2000, AND OTHER APPLICABLE LAWS.",
  "IF THE USER DOES NOT AGREE WITH THIS PRIVACY POLICY, THE USER MUST IMMEDIATELY DISCONTINUE USE OF THE PLATFORM.",
  "⸻",
  "1. COLLECTION OF PERSONAL DATA",
  "1.1 The Platform may collect, receive, process, store, analyze, and retain personal information voluntarily provided by the User, including but not limited to:",
  "(a) full name;",
  "(b) date of birth;",
  "(c) age;",
  "(d) gender;",
  "(e) email address;",
  "(f) mobile number;",
  "(g) profile details;",
  "(h) location-related information;",
  "(i) emergency contact information;",
  "(j) pregnancy-related details;",
  "(k) due date;",
  "(l) communication preferences;",
  "(m) uploaded reports, records, scans, prescriptions, images, or documents;",
  "(n) any other information voluntarily submitted by the User during registration or use of the Platform.",
  "1.2 The User acknowledges and agrees that all information submitted through the Platform is voluntarily provided at the User’s sole discretion and responsibility.",
  "⸻",
  "2. COLLECTION OF SENSITIVE PERSONAL DATA & HEALTH INFORMATION",
  "2.1 The Platform may collect, process, analyze, store, and retain sensitive personal health-related information including but not limited to:",
  "(a) blood pressure readings;",
  "(b) blood sugar values;",
  "(c) pulse rate;",
  "(d) heart rate;",
  "(e) body temperature;",
  "(f) fetal movement data;",
  "(g) kick count information;",
  "(h) symptoms;",
  "(i) dietary information;",
  "(j) weight data;",
  "(k) wellness activity data;",
  "(l) emotional wellness inputs;",
  "(m) pregnancy-related medical history;",
  "(n) medication-related information;",
  "(o) uploaded medical reports, prescriptions, laboratory investigations, and scans;",
  "(p) user-generated pregnancy tracking information;",
  "(q) AI interaction inputs;",
  "(r) communication with experts;",
  "(s) any pregnancy-related or health-related information voluntarily entered by the User.",
  "2.2 The User expressly acknowledges that pregnancy-related health information constitutes sensitive personal data under applicable laws and voluntarily consents to processing of such data by REMEDINART MEDICO SERVICES PRIVATE LIMITED for lawful and operational purposes.",
  "⸻",
  "3. AUTOMATICALLY COLLECTED DATA",
  "3.1 The Platform may automatically collect technical and device-related information including but not limited to:",
  "(a) IP address;",
  "(b) device identifiers;",
  "(c) operating system;",
  "(d) browser type;",
  "(e) application usage activity;",
  "(f) login information;",
  "(g) session activity;",
  "(h) cookies;",
  "(i) analytics data;",
  "(j) crash reports;",
  "(k) network information;",
  "(l) device performance data;",
  "(m) communication logs;",
  "(n) timestamp information;",
  "(o) location-related technical data.",
  "3.2 Such information may be collected through cookies, SDKs, APIs, analytics tools, log files, tracking technologies, or automated technical systems for operational, analytical, performance, security, fraud prevention, and service improvement purposes.",
  ".",
  "⸻",
  "4. PURPOSE OF DATA PROCESSING",
  "4.1 REMEDINART MEDICO SERVICES PRIVATE LIMITED may collect, process, analyze, use, store, disclose, transfer, and retain User data for purposes including but not limited to:",
  "(a) providing Platform services;",
  "(b) pregnancy tracking;",
  "(c) generating personalized wellness insights;",
  "(d) AI-assisted informational support;",
  "(e) enabling expert communication;",
  "(f) providing customer support;",
  "(g) safety monitoring;",
  "(h) service optimization;",
  "(i) analytics and statistical analysis;",
  "(j) fraud prevention;",
  "(k) cybersecurity monitoring;",
  "(l) legal compliance;",
  "(m) internal operational purposes;",
  "(n) communication regarding services, updates, alerts, reminders, or notices;",
  "(o) research and development;",
  "(p) quality assurance;",
  "(q) dispute resolution;",
  "(r) enforcement of legal rights;",
  "(s) protection of Company interests;",
  "(t) regulatory compliance.",
  "⸻",
  "5. USER CONSENT",
  "5.1 By registering on the Platform, the User expressly grants free, informed, unconditional, specific, and affirmative consent for:",
  "(a) collection of personal data;",
  "(b) collection of sensitive personal health data;",
  "(c) processing and analysis of health information;",
  "(d) AI-assisted processing;",
  "(e) automated tracking analysis;",
  "(f) storage and retention of User information;",
  "(g) communication from the Company;",
  "(h) data handling practices described under this Privacy Policy.",
  "5.2 The User acknowledges that refusal to provide certain information may limit or restrict access to specific Platform features or services.",
  "5.3 The User may withdraw consent subject to legal, operational, fraud prevention, medical documentation, cybersecurity, and regulatory compliance requirements.",
  "⸻",
  "6. DATA SHARING & DISCLOSURE",
  "6.1 REMEDINART MEDICO SERVICES PRIVATE LIMITED does not sell identifiable personal health information to third parties for unauthorized commercial exploitation.",
  "6.2 User information may be disclosed, shared, processed, or transferred to:",
  "(a) authorized employees;",
  "(b) healthcare experts;",
  "(c) consultants;",
  "(d) technical support teams;",
  "(e) cloud infrastructure providers;",
  "(f) analytics providers;",
  "(g) payment gateway providers;",
  "(h) communication service providers;",
  "(i) AI service providers;",
  "(j) legal advisors;",
  "(k) auditors;",
  "(l) law enforcement authorities;",
  "(m) regulatory authorities;",
  "(n) governmental authorities;",
  "(o) affiliates or service providers assisting in lawful Platform operations.",
  "6.3 Such disclosures may occur where necessary for:",
  "(a) operational purposes;",
  "(b) legal compliance;",
  "(c) fraud investigation;",
  "(d) cybersecurity protection;",
  "(e) service delivery;",
  "(f) dispute resolution;",
  "(g) regulatory obligations;",
  "(h) enforcement of Company rights;",
  "(i) prevention of unlawful activity.",
  "6B. LEGAL & REGULATORY DISCLOSURES",
  "6B.1 REMEDINART MEDICO SERVICES PRIVATE LIMITED reserves the right to disclose User information where required:",
  "(a) under applicable law;",
  "(b) court orders;",
  "(c) governmental directions;",
  "(d) law enforcement requests;",
  "(e) cybersecurity investigations;",
  "(f) fraud prevention requirements;",
  "(g) protection of legal rights;",
  "(h) public safety obligations.",
  "⸻",
  "7. AI DATA PROCESSING & LIABILITY DISCLAIMER",
  "7.1 User interactions, prompts, questions, responses, uploaded content, and communication with the AI Pregnancy Assistant may be processed, analyzed, reviewed, retained, or utilized for:",
  "(a) AI performance improvement;",
  "(b) system training;",
  "(c) quality enhancement;",
  "(d) safety monitoring;",
  "(e) content moderation;",
  "(f) operational optimization;",
  "(g) pregnancy-related educational assistance.",
  "7.2 The User acknowledges that AI-generated outputs may be inaccurate, incomplete, generalized, delayed, unsuitable, or inconsistent and shall not constitute medical advice, diagnosis, treatment, prescription, emergency intervention, or healthcare supervision.",
  "7.3 REMEDINART MEDICO SERVICES PRIVATE LIMITED shall not be liable for decisions, losses, injuries, complications, damages, or adverse outcomes arising from reliance on AI-generated outputs.",
  "⸻",
  "8. DATA SECURITY & CYBERSECURITY DISCLAIMER",
  "8.1 REMEDINART MEDICO SERVICES PRIVATE LIMITED implements reasonable administrative, technical, operational, and organizational safeguards including encryption mechanisms, authentication systems, restricted access controls, monitoring systems, and cybersecurity practices for protection of User data.",
  "8.2 Notwithstanding reasonable security practices, the User acknowledges and agrees that:",
  "(a) no electronic platform is completely secure;",
  "(b) internet transmissions may be vulnerable;",
  "(c) cybersecurity incidents may occur;",
  "(d) unauthorized access may occur despite safeguards.",
  "8.3 REMEDINART MEDICO SERVICES PRIVATE LIMITED shall not be liable for:",
  "(a) hacking incidents;",
  "(b) cyberattacks;",
  "(c) phishing attacks;",
  "(d) malware;",
  "(e) ransomware;",
  "(f) data theft;",
  "(g) server breaches;",
  "(h) unauthorized access;",
  "(i) third-party cybersecurity failures;",
  "(j) internet disruptions;",
  "(k) cloud service failures;",
  "(l) technical vulnerabilities beyond reasonable control.",
  "8.4 NO ABSOLUTE GUARANTEE OF CONFIDENTIALITY",
  "While REMEDINART MEDICO SERVICES PRIVATE LIMITED implements reasonable safeguards, the Company does not guarantee absolute confidentiality, uninterrupted security, or complete immunity from unauthorized access, cyber incidents, or technological vulnerabilities.",
  "⸻",
  "9. DATA RETENTION",
  "9.1 User data may be retained for such duration as deemed necessary by REMEDINART MEDICO SERVICES PRIVATE LIMITED for:",
  "(a) service continuity;",
  "(b) legal compliance;",
  "(c) operational requirements;",
  "(d) medical documentation;",
  "(e) fraud prevention;",
  "(f) cybersecurity purposes;",
  "(g) dispute resolution;",
  "(h) enforcement of legal rights;",
  "(i) audit requirements;",
  "(j) analytics and research in anonymized form.",
  "9.2 The Company reserves the right to retain information where legally required or operationally necessary notwithstanding deletion requests.",
  "⸻",
  "10. USER RIGHTS",
  "10.1 Subject to applicable laws, Users may request:",
  "(a) access to personal data;",
  "(b) correction of inaccurate information;",
  "(c) withdrawal of consent;",
  "(d) deletion of eligible data;",
  "(e) grievance redressal.",
  "10.2 REMEDINART MEDICO SERVICES PRIVATE LIMITED reserves the right to reject, restrict, defer, or partially comply with requests where necessary for:",
  "(a) legal obligations;",
  "(b) fraud prevention;",
  "(c) cybersecurity concerns;",
  "(d) dispute resolution;",
  "(e) ongoing investigations;",
  "(f) operational continuity;",
  "(g) regulatory compliance.",
  "⸻",
  "11. COMMUNITY PRIVACY DISCLAIMER",
  "11.1 Users participating in community forums, chats, discussion groups, or communication features acknowledge that voluntarily shared information may become visible to other Users.",
  "11.2 Users shall not publicly share:",
  "(a) medical reports;",
  "(b) personal contact details;",
  "(c) confidential information;",
  "(d) passwords;",
  "(e) financial information;",
  "(f) highly sensitive personal data.",
  "11.3 REMEDINART MEDICO SERVICES PRIVATE LIMITED shall not be responsible for misuse, disclosure, copying, forwarding, or unauthorized sharing of information voluntarily disclosed by Users within community features.",
  "⸻",
  "12. CHILDREN’S PRIVACY",
  "12.1 The Platform is intended solely for Users above 18 years of age.",
  "12.2 REMEDINART MEDICO SERVICES PRIVATE LIMITED does not knowingly collect personal data from minors.",
  "12.3 The Company reserves the right to suspend or terminate accounts suspected to belong to minors.",
  "⸻",
  "13. THIRD-PARTY SERVICES DISCLAIMER",
  "13A. CROSS-BORDER DATA TRANSFER",
  "13A.1 The User acknowledges and agrees that certain data may be processed, stored, backed up, analyzed, or transferred through third-party infrastructure, cloud systems, analytics systems, AI systems, or service providers located outside India subject to applicable legal safeguards and contractual protections.",
  "13A.2 By using the Platform, the User expressly consents to such cross-border transfer, storage, and processing of data where operationally necessary.",
  "13.2 REMEDINART MEDICO SERVICES PRIVATE LIMITED shall not be responsible for independent privacy practices, technical failures, inaccuracies, delays, breaches, losses, or conduct of third-party service providers.",
  "⸻",
  "14. PLATFORM MISUSE & RESTRICTION RIGHTS",
  "14.1 REMEDINART MEDICO SERVICES PRIVATE LIMITED reserves absolute and unrestricted rights to monitor activity, investigate misuse, restrict access, suspend accounts, permanently terminate Users, remove content, preserve records, cooperate with authorities, and initiate legal proceedings in cases involving:",
  "(a) misuse of the Platform;",
  "(b) suspicious activity;",
  "(c) fraudulent conduct;",
  "(d) unlawful behavior;",
  "(e) abusive communication;",
  "(f) cybersecurity threats;",
  "(g) misinformation;",
  "(h) policy violations;",
  "(i) reputational harm;",
  "(j) operational risk;",
  "(k) unethical conduct;",
  "(l) violation of applicable laws.",
  "14.2 The determination of misuse or policy violation shall remain solely at the discretion of REMEDINART MEDICO SERVICES PRIVATE LIMITED.",
  "⸻",
  "⸻",
  "16. MODIFICATION OF PRIVACY POLICY",
  "16.1 REMEDINART MEDICO SERVICES PRIVATE LIMITED reserves unrestricted rights to modify, revise, amend, update, suspend, or replace this Privacy Policy at any time without prior notice.",
  "16.2 Continued use of the Platform following such modification shall constitute deemed acceptance of the revised Privacy Policy.",
  "⸻",
  "17. GOVERNING LAW & JURISDICTION",
  "17.1 This Privacy Policy shall be governed by and construed in accordance with the laws of India.",
  "17.2 Any disputes arising in connection with this Privacy Policy shall be subject to arbitration under the Arbitration and Conciliation Act, 1996.",
  "17.3 Courts situated in Maharashtra, India shall have exclusive jurisdiction.",
  "⸻",
  "18. CONTACT & GRIEVANCE OFFICER",
  "18.1 For privacy concerns, grievance redressal, consent withdrawal requests, or legal communication, Users may contact the designated Grievance Officer of REMEDINART MEDICO SERVICES PRIVATE LIMITED through official communication channels provided on the Platform.",
  "19.BUSINESS TRANSFER CLAUSE",
  "19.1BUSINESS TRANSFER & CORPORATE RESTRUCTURING",
  "In the event of merger, acquisition, restructuring, investment, insolvency, business transfer, asset sale, or corporate reorganization involving REMEDINART MEDICO SERVICES PRIVATE LIMITED, User data may be transferred subject to applicable confidentiality and legal obligations.",
  "20. ACCOUNT DELETION REQUESTS",
  "20.1 Users may request deletion of their account subject to verification, legal retention obligations, fraud prevention requirements, ongoing disputes, operational dependencies, cybersecurity obligations, and applicable laws.",
  "20.2 Certain records may continue to be retained in backup systems, audit systems, legal archives, or anonymized databases for lawful purposes.",
  "REFUND POLICY",
  "1. ELIGIBLE REFUND CONDITIONS",
  "1.1 Refunds may be considered ONLY under the following limited circumstances:",
  "(a) Duplicate Payment:",
  "Where the User has been charged more than once for the same transaction, subscription, or billing event due to technical or payment-related issues.",
  "(b) Payment Deducted but Subscription Not Activated:",
  "Where payment has been successfully deducted from the User’s account but the subscribed service, plan, or access has not been activated and the issue remains unresolved after reasonable verification.",
  "(c) Major Unresolved Technical Failure:",
  "Where the Platform becomes substantially inaccessible or core paid services remain completely unavailable for a prolonged duration directly due to verified technical failure attributable solely to REMEDINART MEDICO SERVICES PRIVATE LIMITED, and the issue cannot be reasonably resolved within an appropriate operational timeframe.",
  "1.2 Refunds shall NOT be provided under any circumstances including but not limited to:",
  "(a) dissatisfaction with pregnancy outcomes;",
  "(b) miscarriage, stillbirth, congenital defects, fetal abnormalities, developmental disorders, maternal complications, neonatal complications, hospitalization, delivery complications, or any pregnancy-related medical condition;",
  "(c) dissatisfaction with AI-generated responses, wellness recommendations, expert communication, Garbhasanskar activities, community discussions, or emotional support services;",
  "(d) subjective dissatisfaction, emotional dissatisfaction, change of preference, or change of expectations;",
  "(e) failure by the User to utilize subscribed services;",
  "(f) discontinuation of pregnancy;",
  "(g) delayed or failure by the User to seek medical consultation, emergency care, hospitalization, or physical examination;",
  "(h) inaccurate or incomplete health data entered by the User;",
  "(i) technical issues arising from User devices, internet connectivity, operating systems, third-party applications, or external technical limitations not attributable to the Company;",
  "(j) account suspension, restriction, or termination resulting from misuse, abuse, policy violation, unlawful conduct, misinformation, harassment, fraudulent activity, or breach of Terms & Conditions;",
  "(k) partial or substantial consumption of Platform services including but not limited to:",
  "(i) AI assistant usage;",
  "(ii) expert support usage;",
  "(iii) wellness activity access;",
  "(iv) premium content consumption;",
  "(v) health tracking usage;",
  "(vi) community participation;",
  "(vii) downloaded resources;",
  "(viii) attended sessions or consultations;",
  "(l) failure by the User to understand the nature, limitations, disclaimers, or intended purpose of the Platform as disclosed under the Terms & Conditions, Medical Disclaimer, Privacy Policy, or other applicable documents.",
];

function TermsOfUseAppSection() {
  return (
    <section className="pt-4">
      <h2 className="text-center fw-bold py-4 my-4 text-uppercase border-top border-bottom border-3">
        TERMS OF APP USE
      </h2>
      {termsOfUseAppParagraphs.map((paragraph, index) => {
        if (paragraph === "⸻") {
          return (
            <p key={`${paragraph}-${index}`} className="text-center my-3">
              {paragraph}
            </p>
          );
        }

        return <p key={`${paragraph}-${index}`}>{paragraph}</p>;
      })}
    </section>
  );
}

export default TermsOfUseAppSection;
